<template>
	<Page animate class="cancel-sub-offer-page">
		<template v-slot:content>
			<SafeAreaTop :show-close="false">
				<div class="container mt-10vh">
					<img class="img-fluid" src="@/assets/present-2x.png" alt="" />
					<Title class="tac mb-md">{{ t('title') }}</Title>
					<Subtitle class="subtitle tac">{{ t('subtitle') }}</Subtitle>
					<Products class="mb-xl" :products="products" :active="active_product" theme="orange" />

					<PButton class="mb-xl" @click.prevent="handleSubmit" :loading="isLoading" cls="btn-purple btn-block">
						{{ t('button') }}
					</PButton>
					<a class="btn btn-text btn-color-lightgray btn-block" href="" @click.prevent="onClose">
						{{ t('decline') }}
					</a>
				</div>
			</SafeAreaTop>

			<Prompt
				:isOpen="showPaywallCancelPrompt"
				:title="t('cancel_popup.title')"
				:text="t('cancel_popup.body', { store: platform === 'ios' ? 'iTunes Store' : 'Play Store' })"
				:action="t('cancel_popup.action')"
				@onClose="onClosePaywallCancelPrompt"
				@onAction="onActionPaywallCancelPrompt"
			/>
		</template>
	</Page>
</template>

<script setup>
import Page from '@/components/Page'
import SafeAreaTop from '@/components/SafeAreaTop'
import Prompt from '@/components/Prompt'
import Products from '@/components/products/ios/Products'
import PButton from '@/components/Button'
import Title from '@/views/pre/survey/components/Title'
import Subtitle from '@/views/pre/survey/components/Subtitle'
import { useI18n } from 'vue-i18n'
import { computed, inject, watch } from '@vue/runtime-core'
import { useStore } from 'vuex'
import useConfig from '@/composition/config'
import { ref } from '@vue/reactivity'
import useApi from '@/composition/api'

const api = useApi()
const config = useConfig()
const store = useStore()
const amplitude = inject('amplitude')
const platform = api.getPlatform()

const { t } = useI18n({
	useScope: 'global',
	messages: {
		en: {
			title: 'Thanks, take your discount on Simple Premium',
			subtitle: 'Grab a special offer!  A year with Simple',
			button: 'Get the Offer',
			decline: 'decline'
		}
	}
})

const showPaywallCancelPrompt = ref(false)

function onClosePaywallCancelPrompt() {
	showPaywallCancelPrompt.value = false
}

function onActionPaywallCancelPrompt() {
	showPaywallCancelPrompt.value = false
	Purchase(active_product.value)
}

const products = computed(() =>
	store.getters['products/getData']([
		Object.assign(
			{
				id: 'simple_sale_subscription_12_months_63off_no_trial',
				old: {
					id: 'simple_original_premium_subscription_12_months'
				},
				text: '<span class="text-gray">[old_price]</span> <span class="text-dark">→</span> [price]/year',
				badge: '70% OFF'
			},
			config.get({ key: 'paywall.top_product', default_value: {} })
		)
	])
)

const active_product = ref(products.value[0])
watch(products, () => {
	active_product.value = products.value[0]
})

function close(Status = 'Close') {
	amplitude.logEvent('Cancel Sub Offer - Close', {
		Layout: config.get({ key: 'layout', default_value: 'Cancel Sub Survey' }),
		From: store.getters['getSource'],
		Step: 'Paywall',
		Status
	})
	api.close()
}

function onClose() {
	close()
}

function Purchase(product) {
	api.purchase({
		productId: product.id,
		onFinish: () => {
			amplitude.logEvent('Cancel Sub Offer - Done', {
				Layout: config.get({ key: 'layout', default_value: 'Cancel Sub Survey' }),
				From: store.getters['getSource'],
				Step: 'Paywall',
				ProductId: product.id,
				Status: 'Subscribe'
			})
			close('Subscribe')
		},
		onError: () => {
			console.log('error')
		},
		onCancel: () => {
			showPaywallCancelPrompt.value = true
		},
		closeOnSuccess: false
	})
}

function handleSubmit() {
	Purchase(active_product.value)
}

const isLoading = computed(() => store.state.isLoading)
</script>

<style scoped>
.cancel-sub-offer-page {
	color: #424982;
}
</style>
